import React from "react";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Data
import data from "../../../data/labs.json";

// Components
import SearchBar from "../../Common/SearchBar/SearchBar";
import Tag from "../../Common/Tag/Tag";
import Magnetic from "../../Common/Magnetic/Magnetic";

// SCSS
import "./LabWindow.scss";

const LabWindow = ({ setHoveredElement }) => {
  // Search
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = data.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    const titleMatch = item.title.toLowerCase().includes(lowerSearch);
    const tagMatch = item.tags.some((tag) =>
      tag.toLowerCase().includes(lowerSearch),
    );

    return titleMatch || tagMatch;
  });

  return (
    <div className="LabWindow">
      <section className="Search">
        <div className="Search__Wrapper">
          <SearchBar value={searchTerm} onChange={setSearchTerm} />
        </div>
      </section>
      <section className="Content">
        <AnimatePresence mode="popLayout">
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <motion.div
                key={item.id}
                className="Content__Item__Wrapper"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.2 }}
              >
                <Magnetic
                  setHoveredElement={setHoveredElement}
                  as="a"
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="Content__Item"
                >
                  <div className="Content__Image">
                    <img
                      src={item.thumbnail}
                      alt={item.title}
                      className="Content__Image-Tumbnail"
                    />
                  </div>
                  <div className="Content__Text">
                    <span className="Content__Text-Title">{item.title}</span>
                    <div className="Content__Text-Tag">
                      {item.tags.map((tag) => (
                        <Tag key={tag} text={tag} />
                      ))}
                    </div>
                  </div>
                </Magnetic>
              </motion.div>
            ))
          ) : (
            <p className="NoResult">No Result!</p>
          )}
        </AnimatePresence>
      </section>
    </div>
  );
};

export default LabWindow;
